import type { Tone } from '../../../util/term'

/**
 * Tones whose mark renders a solid fill behind the number — number
 * color must flip to paper-white for legibility. Hollow tones keep
 * the dark cell-default number color.
 */
export const FILLED_TONES: ReadonlySet<Tone> = new Set([
  'albatross',
  'eagle',
  'double',
  'triple',
])
